import { Link } from "react-router-dom";
import NewsRow from "../news/NewsRow";
import { useNewsItems } from "../news/useNewsItems";

export default function HomeNews() {
  const { items } = useNewsItems();
  return (
    <section className="section news">
      <div className="container">
        <h2 className="home-h2">
          <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
          お知らせ<strong>News</strong>
        </h2>
        <div className="row-list">
          {items.slice(0, 3).map((item) => (
            <NewsRow key={item.key} item={item} />
          ))}
        </div>
        <div className="more">
          <Link to="/news">お知らせをすべて見る →</Link>
        </div>
      </div>
    </section>
  );
}
